// extracted by mini-css-extract-plugin
export var productImage = "_r7-1";
export var viewLink = "_r7-2";
export var wishlistItem = "_r7-0";